import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { NavigationLinkComponent } from './link/navigation-link.component';

/**
 * This component is reponsible for the display of the basic navigation that is visible
 * on all authenticated pages.
 *
 * @export
 * @class NavigationComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'hypecast-master-admin-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavigationLinkComponent],
})
export class NavigationComponent {
  readonly authenticationService = inject(AuthenticationService);
}
